<template>
  <div class="inventory">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button @click="$router.go(-1)" class="btn fixed_btn">Back</button>
      <div v-if='order' class="card">
        <p class="title">{{order.order_number}}</p>
        <p class='date'>{{order.created_at | format_date_time}}</p>
        <div class='list'>
            <div class='item'>
                <p class='title'>Order Status</p>
                <p>{{order.status}}</p>
            </div>
            <div class='item'>
                <p class='title'>Shipping Address</p>
                <p>{{order.shipping_address.address_1}}</p>
                <p>{{order.shipping_address.address_2}}</p>
                <p>{{order.shipping_address.city + ', ' + order.shipping_address.state + ' ' + order.shipping_address.zip}}</p>
            </div>
            <div class='item'>
                <p class='title'>Billing Address</p>
                <p>{{order.billing_address.address_1}}</p>
                <p>{{order.billing_address.address_2}}</p>
                <p>{{order.billing_address.city + ', ' + order.billing_address.state + ' ' + order.billing_address.zip}}</p>
            </div>
            <div class='item'>
                <p class='title'>Order Total</p>
                <p>{{formatPrice(order.total)}}</p>
            </div>
        </div>
      </div>

      <div v-if='order' class="card">
        <p class="title">Products</p>
        <table v-if='!units.length'>
          <thead>
            <tr>
              <th>Product Name</th>
                <th>Product Sku</th>
                <th>Unit Price</th>
                <th>Quantity</th>
                <th>Total Price</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, i) in line_items">
                <tr :key="i" :class="{ grey: i % 2 }">
                    <td data-label="Product Name">{{ item.name }}</td>
                    <td data-label="Product Sku">{{ item.sku }}</td>
                    <td data-label="Unit Price">{{ formatPrice(item.unit_price) }}</td>
                    <td data-label="Quantity">{{ item.quantity }}</td>
                    <td data-label="Total Price">{{ formatPrice(item.total_price) }}</td>
                </tr>
            </template>
          </tbody>
        </table>
        
        <table v-if='units.length'>
          <thead>
            <tr>
              <th>Serial</th>
                <th>Tracking Number</th>
                <th>Tracking Carrier</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, i) in units">
                <tr :key="i" :class="{ grey: i % 2 }">
                    <td data-label="Product Name">{{ item.serial_num }}</td>
                    <td data-label="Product Sku">{{ item.tracking.carrier }}</td>
                    <td data-label="Unit Price">{{ formatPrice(item.tracking.number) }}</td>
                </tr>
            </template>
          </tbody>
        </table>
      </div>

        <div v-if='order' class="card">
            <p class="title">Client: {{order.client.companyName}}</p>
            <div class='list'>
                <div class='item'>
                    <p class='title'>Company Name</p>
                    <p>{{order.client.companyName}}</p>
                </div>
                <div class='item'>
                    <p class='title'>Contact Info</p>
                    <p>{{order.client.first_name + ' ' + order.client.last_name}}, {{order.client.title}}</p>
                    <p>{{order.client.email}}</p>
                    <p>{{order.client.phone}}</p>
                </div>
            </div>
        </div>
    </div>
    
  </div>
</template>

<script>
import Swal from "sweetalert2";
import firebase from "firebase";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
const functions = fb.default.functions;

export default {
  name: "orderdetails",
  data() {
    return {
        order: null,
        line_items: null,
        units: null,
        reseller: this.$store.state.reseller,
    };
  },
  firestore() {
    return {
      order: db
        .collection(`reseller_profile/${this.reseller.id}/orders`)
        .doc(this.$route.params.id),
    line_items: db
        .collection(`reseller_profile/${this.reseller.id}/orders/${this.$route.params.id}/line_items`),
    units: db
        .collection(`reseller_profile/${this.reseller.id}/orders/${this.$route.params.id}/units`)
    };
  },
  created() {
  },
};
</script>

<style scoped lang="scss">
.date {
    color: #49c6d4;
    margin-top: -20px;
    font-weight: bold;
    margin-bottom: 30px;
}

.client {
    padding-top: 30px;
    margin-top: 20px;
    border-top: 2px solid #eaeaea;
}

</style>
